import { useCallback, useEffect, useState } from 'react';

import { DomainObject, Params } from 'types';

import { fetchList } from '../grid-api';

const DEFAULT_PARAMS = {};

export function useFetchList<TObject extends DomainObject = DomainObject>(
  url: string,
  defaultParams: Params = DEFAULT_PARAMS,
  disableLoad: boolean = false
) {
  const [items, setItems] = useState<TObject[]>([]);
  const [searchAfter, setSearchAfter] = useState<string | undefined>();
  const [count, setCount] = useState(0);

  const getData = useCallback(
    async (isRefresh: boolean) => {
      try {
        const params = { ...defaultParams };
        if (!isRefresh) {
          params.searchAfter = searchAfter;
        }

        const response = await fetchList<TObject>(url, params);

        setCount(response.count!);
        setSearchAfter(response.searchAfter!);
        if (isRefresh) {
          setItems(response.items!);
        } else {
          setItems((i) => [...i, ...response.items!]);
        }
      } catch (e) {
        console.log(e);

        setCount(0);
        setItems([]);
        setSearchAfter(undefined);
      }
    },
    [defaultParams, searchAfter, url]
  );

  const fetchMore = useCallback(() => getData(false), [getData]);
  const refreshList = useCallback(() => getData(true), [getData]);

  useEffect(() => {
    if (!disableLoad) {
      refreshList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [disableLoad, defaultParams, url]);

  return { items, count, refreshList, fetchMore };
}
